<template>
  <div class="login">
    <slot />
  </div>
</template>

